import { InfoCircle } from "../../../../assets/icons";
import { useTranslation } from "react-i18next";
import "./AdvancedSettingsInfo.scss";

const AdvancedSettingsInfo = () => {
  const { t } = useTranslation();
  return (
    <div className="new-advance-settings-note">
      <span className="new-advance-settings-note__icon">
        <InfoCircle />
      </span>
      <span className="new-advance-settings-note__text">
        {t("advanceSettings.note")}
      </span>
    </div>
  );
};

export default AdvancedSettingsInfo;
